module.exports = __webpack_public_path__ + "static/media/delivery.4054d477.svg";